import { useQuery } from "react-query";
import Axios from "../axios-proas";
import axios from 'axios'
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { auth } from '../store/actions/auth'; // Assurez-vous d'importer correctement votre action Redux
import { useNavigate, useLocation, useParams } from 'react-router-dom';


//const claimTypeRole = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
//const claimNameIdentifier = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
// Temporary or not
const claimTypeRole = "role";
const claimNameIdentifier = "sub";

const claimsKeys = {
    claim: ["claimss"],
};

const config = {
    headers: {
        "X-CSRF": "1",
    },
};

const getTypeUser = (roles, rolesUser) => {

    if (roles != null && rolesUser != null) {
        let rolesBO = roles.filter((role, index) => role.type == "OperateurBackOffices").map((item) => item.libelle)
        let rolesBailleur = roles.filter((role, index) => role.type == "Bailleurs").map((item) => item.libelle)
        let rolesLocataire = roles.filter((role, index) => role.type == "Locataires").map((item) => item.libelle)

        const userType = rolesUser.some(item => rolesBO.includes(item)) ? "ADMIN_YOUNOV" :
              rolesUser.some(item => rolesBailleur.includes(item)) ? "BAILLEUR" :
              rolesUser.some(item => rolesLocataire.includes(item)) ? "LOCATAIRE" : "";

        return userType
    }
    else
         return ""
   
}

const fetchClaims = async () =>
    Axios.get(import.meta.env.VITE_API_USER_URL).then((res) => res.data).catch((err) => console.log(err));
function useClaims() {
    return useQuery(
        claimsKeys.claim,
        async () => {
            return fetchClaims(); // Renvoyer directement le résultat de fetchClaims()
        },
        {
            retry: false,
        }
    );
}
function useAuthUser() {    
    const location = useLocation()  
    if (location.pathname != "/") {
        localStorage.setItem('parentLocation', location.pathname);
    }
    const dispatch = useDispatch();
    const { data: claims, isLoading } = useClaims();

    let logoutUrl = claims?.find((claim) => claim.type === "bff:logout_url");
    let nameDict =claims?.find((claim) => claim.type === "name") ||claims?.find((claim) => claim.type === "sub");
    let username = nameDict?.value;
    let access_data_key = claims?.filter((claim) => claim.type === "access_data_key");
    access_data_key = access_data_key?.map((item, index) => { return item.value })

  let permissions = claims?.filter((claim) => claim.type === "permissions");
  permissions = permissions?.map((item, index) => { return item.value })


    let access_data_assu_key = claims?.filter((claim) => claim.type === "access_data_assu_key");
    access_data_assu_key = access_data_assu_key?.map((item, index) => { return item.value })

    let bailleur_id = claims?.find((claim) => claim.type === "bailleur_id")?.value
    let enquete_id = claims?.find((claim) => claim.type === "enquete_id")?.value
    let rolesOfUser = claims?.filter((claim) => claim.type === claimTypeRole)?.map((item, index) => { return item.value })
 
    let userType = "";
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    let connectedUserId = claims?.filter((claim) => claim.type === claimNameIdentifier)[0].value
    let tenant_branding = claims?.find((claim) => claim.type === "tenant_branding")?.value
    useEffect(() => {
        if (username!=null)
            Axios.get(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/getAllRoles', config).then((response) => {
                setIsLoggedIn(!!username);
                localStorage.setItem('isConnected', !!username);
                userType = getTypeUser(response.data, rolesOfUser)
              dispatch(auth(connectedUserId, username, userType, rolesOfUser, access_data_key, access_data_assu_key, permissions, bailleur_id, enquete_id, tenant_branding, logoutUrl?.value));
          
            }).catch(err => {
                
            })       
    }, [username ]);

 
        return {
            connectedUserId,
            username,
            logoutUrl,
            isLoading,
            isLoggedIn,
            access_data_key,
            access_data_assu_key,
            bailleur_id,
            enquete_id,
            rolesOfUser
        };   
  
}

export { useAuthUser };
